import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import AuthService from '../../../Services/authService';

export default class OpportunityPOCExportSearchParams extends SearchParamsBase {
  static saveType = 'OpportunityPOCExportSearchParams';
  initialize() {
    this.OfficeIds = OpportunityPOCExportSearchParams.getUserOffice();
    this.ClientIsActive = null;
    this.StatusCodes = [];
    this.ActualStartDateFrom = new Date();
    this.ActualEndDateTo = new Date();
    this.ModifiedOnFrom = new Date();
    this.ModifiedOnTo = new Date();
  }

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId);
  }
}
